<template>
    <div class="container-fluid">
        <notifications></notifications>

        <div class="confirm">
            <div class="card text-center p-sm-5 p-3" style="width: 25rem;">
                <h5 class="card-title"><img src="/assets/logo/logo_white.svg" alt=""></h5>

                <div class="card-body">

                    <h1>Bevestiging</h1>
                    <div v-if="loading">
                        Aan het laden...
                    </div>
                    <div v-else>
                        <p v-if="active">
                            Hartelijk dank voor uw betaling.<br>
                            De automatische incasso is correct verwerkt
                        </p>
                        <div class="alert alert-danger" v-if="active">
                            <h2>Let op!</h2>
                            De bevestigingsmail belandt mogelijk in uw spambox.
                        </div>

                        <p v-if="!active">
                            De betaling is mislukt, u heeft een email met instructies ontvangen om het opnieuw te proberen.
                        </p>
                        <div class="alert alert-danger" v-if="!active">
                            <h2>Let op!</h2>
                            De mail met instructies belandt mogelijk in uw spambox.
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import axios from 'axios'
    import Notifications from "../helper/notifications";

    export default {
        name: "confirm",
        components:{Notifications},
        data() {
            return {
                loading: true,
                active : false
            }
        },
        created() {
            this.$store.dispatch('get','api/v1/confirm/'+this.$route.params.customerId)
            .then((data)=>{
                console.log('DEZE', data, data.data.active);
                this.active = data.data.active;
                if(data.error){
                    this.active = 0;
                }
                this.loading = false;
            });
        }
    }
</script>

<style scoped>
    .container-fluid {
        height: 100vh;
        background: transparent linear-gradient(270deg, #73AFE3 0%, #CFE4F6 100%) 0% 0% no-repeat padding-box;
        opacity: 1;
    }

    .confirm {
        display: flex;
        height: 100vh;
        align-items: center;
        justify-content: center;
    }

    .card {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 20px;
        opacity: 1;
    }

    .form-control {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        height: calc(1.5em + .75rem + 8px) !important;
        font-size: 15px !important;
    }

    .text-white {
        font-size: 15px !important;
    }

    .btn {
        background: #292929 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029 !important;
        border-radius: 4px !important;
        padding-left: 15%;
        padding-right: 15%;
        font-size: 18px !important;
    }


</style>
